import React, { useEffect, useState } from "react";
const Spinner = ({ text = "Loading..." }) => {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const interval = setInterval(() => {
      setVisible((prev) => !prev);
    }, 500);

    return () => clearInterval(interval);
  }, []);
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        backgroundColor: "rgba(255,255,255,0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        borderRadius: "inherit",
      }}
    >
      <div className="d-flex flex-column align-items-center">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        />
        <div
          className="mt-2 fw-semibold"
          style={{
            color: "#0d6efd",
            opacity: visible ? 1 : 0.3,
            transition: "opacity 0.4s ease",
          }}
        >
          {text}
        </div>
      </div>
    </div>
  );
};

export default Spinner;